import React from 'react';

const Ingredientes = () => {
  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        
        {/* --- TÍTULO DA SEÇÃO (Agora em Branco) --- */}
        <h2 style={styles.title}>
          QUAIS OS INGREDIENTES DA GUMMY?
        </h2>

        {/* --- IMAGEM OFICIAL --- */}
        <img 
          src="https://d1a9qnv764bsoo.cloudfront.net/stores/006/020/968/rte/o%20que%20tem%20na%20gummy.jpg" 
          alt="Tabela Nutricional e Ingredientes da Gummy" 
          style={styles.image}
        />

      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 20px', // Aumentei um pouco o padding vertical
    backgroundColor: '#ffffff', // MUDANÇA 1: Fundo agora é o ROXO da marca
    textAlign: 'center'
  },
  container: {
    maxWidth: '850px', // MUDANÇA 2: Diminuí a largura de 1000px para 850px
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    color: '#5D2E8C', // MUDANÇA 3: Cor do texto passou para BRANCO para contrastar
    fontSize: '2.5rem',
    fontFamily: '"Titan One", sans-serif',
    marginBottom: '40px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    lineHeight: '1.2'
  },
  image: {
    width: '100%',
    height: 'auto',
    maxWidth: '100%',
    borderRadius: '25px', // Arredondamento maior para ficar mais bonito
    // Sombra mais marcada para destacar a imagem do fundo roxo
    boxShadow: '0 25px 50px rgba(0,0,0,0.25)' 
  }
};

export default Ingredientes;